<!-- 操作中心 -->
<template>
  <div class="operational">
    <el-popover placement="bottom-start" trigger="hover">
      <div class="feet">
        <!--批量添加费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="onBatchAddingcosts"
        >{{ $t('receivablePayable.AddChargesInBulk') }}
        </el-button>

        <!--导入添加费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="isImportAdd = true"
        >{{ $t('receivablePayable.ImportAddCharges') }}
        </el-button>

        <!--导入修改费用-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="isImportEdit = true"
        >{{ $t('receivablePayable.ImportModifyExpenses') }}
        </el-button>

        <!--快录新增-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="onQR"
        >{{ $t('receivablePayable.QuickRecord') }}
        </el-button>

        <!--批量导入快录-->
        <el-button
          size="small" type="primary" class="feet-btn"
          @click="onQRImport"
        >{{ $t('receivablePayable.BatchImportClips') }}
        </el-button>
      </div>
      <!--运输不显示-->
      <template #reference>
        <el-button
          v-if="![5].includes(payableType)"
          v-permit:remove="permissionList[payableType].edit"
          :loading="isAddAndEdit"
          size="small"
        >
          {{ $t('receivablePayable.AddModifyExpenses') }}
        </el-button>
      </template>
    </el-popover>

    <!-- 生成应付 -->
    <el-button
      v-permit:remove="permissionList[payableType].meet"
      :loading="isAddAndEdit"
      type="primary"
      size="small"
      @click="onGenerateCope"
    >{{ $t('basicData.GeneratePayables') }}</el-button>

    <!-- 备注（含弹出窗） -->
    <RemarkButCmp
      :ids="selectIdArr"
      :payable-type="payableType"
      :async-sumbit="asyncRemark"
    />

    <!-- 导出 -->
    <el-button
      v-permit:remove="permissionList[payableType].export"
      size="small" @click="onExport"
    >{{ $t('receivablePayable.Export') }}</el-button>

    <div v-permit:remove="permissionList[payableType].rerun">
      <!-- 重新计算（第三方/安俊） -->
      <RecalculateButCmp
        v-if="[1, 2].includes(payableType)"
        v-permit:remove="'btn:finance:payableManagement:hut:RecalculateThePrice' || 'btn:finance:payableManagement:threeCollect:RecalculateThePrice'"
        :payable-type="payableType" @submit="onRecalculate"
      />

      <!-- AJD重算 -->
      <el-button
        v-else-if="payableType === 3" v-permit:remove="'btn:finance:payableManagement:ajd:RecalculateThePrice'"
        size="small" @click="onRerun"
      >{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>

      <!-- DSP重算/邮局派送 -->
      <el-popover
        v-else-if="[4,6].includes(payableType)"
        v-permit:remove="'btn:finance:payableManagement:dsp:RecalculateThePrice' || 'btn:finance:payableManagement:postOfficeDelivery:RecalculateThePrice'"
        placement="bottom-start"
        trigger="hover"
      >
        <el-button slot="reference" size="small">{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>
        <div class="feet">
          <!-- 重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(1)"
          >{{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
          <!-- 导入计算价格 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(2)"
          >{{ $t('receivablePayable.ImportCalculatePrices') }}
          </el-button>
          <!-- 重量批量导入价格 -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRerunDSP(3)"
          >{{ $t('receivablePayable.ImportWeightsCalculatePrices') }}
          </el-button>
        </div>
      </el-popover>

      <!--运输干支线重算费用-->
      <el-popover
        v-else-if="[5].includes(payableType)"
        v-permit:remove="'btn:finance:payableManagement:transportation:RecalculateThePrice'"
        placement="bottom-start"
        trigger="hover"
      >
        <el-button slot="reference" size="small">{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>
        <div class="feet">
          <!-- 重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRecalculateThePrice(1)"
          >{{ $t('receivablePayable.RecalculateThePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
          <!-- 更新重新计算价格 10W -->
          <el-button
            size="small" type="primary" class="feet-btn"
            @click="onRecalculateThePrice(2)"
          >{{ $t('receivablePayable.updateDataRecalculatePrice') + '(' + $t('receivablePayable.Maximum100000') + ')' }}
          </el-button>
        </div>
      </el-popover>

      <!--邮局派送-->
      <!--      <el-button-->
      <!--        v-else-if="payableType === 6"-->
      <!--        v-permit:remove="'btn:finance:payableManagement:postOfficeDelivery:RecalculateThePrice'"-->
      <!--        size="small" @click="onRerunYj"-->
      <!--      >{{ $t('receivablePayable.RecalculateThePrice') }}</el-button>-->
    </div>

    <!-- AJD-dialog -->
    <RerunDialog ref="rerunRef" @submit="onRecalculate" />

    <!-- DSP导入重算 -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="titleList[calculationType]"
      :visible.sync="showImportTemplate"
      width="600px"
    >
      <importDsp
        :key="showImportTemplate"
        :calculation-type="calculationType"
        @importPrice="importPrice"
      />
    </el-dialog>

    <!--运输干支线重算-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.RecalculateThePrice')"
      :visible.sync="showRecalculateThePrice"
      width="600px"
    >
      <recalculate :key="showRecalculateThePrice" @saveReCalculate="saveReCalculate" />
    </el-dialog>

    <!-- 删除（含弹出窗） -->
    <DelButCmp
      :async-sumbit="asyncDel"
      :payable-type="payableType"
    />

    <!-- 自定义列栏目 -->
    <CustomStatusBar :payable-type="payableType" />

    <!-- 生成应付弹窗 -->
    <AccountsPayable
      ref="generateCopeTimeRef"
      :cb="generateReceivablesSuccess"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      :provider-data="providerData"
      :fee-type-option="feeTypeOption"
    />

    <!-- 显示生成应付结果弹窗 -->
    <AccountsPayableDialog ref="generateCopeListRef" />

    <!-- 批量添加费用 -->
    <AddFee
      ref="notQRAddRef"
      :fee-type-option="feeTypeOption"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      @close="onQRClose"
    />

    <!-- 非快录详情 -->
    <DetailFee
      ref="notQRDetailsRef"
      :query-fee-param="queryFeeParam"
      :fee-type-option="feeTypeOption"
      :query-form="queryForm"
      :select-data="selectArr"
      :payable-type="payableType"
      @close="onQRClose"
    />

    <!-- 导入添加费用 -->
    <el-dialog
      :title="$t('receivablePayable.ImportAddCharges')"
      :visible.sync="isImportAdd"
      width="600px"
    >
      <importAddFees :payable-type="payableType" :fee-type-list="feeTypeOption" @colse="onImportAddClose" />
    </el-dialog>

    <!-- 导入修改费用 -->
    <el-dialog
      :title="$t('receivablePayable.ImportModifyExpenses')"
      :visible.sync="isImportEdit"
      width="600px"
    >
      <importEditFees :payable-type="payableType" :fee-type-list="feeTypeOption" @changeFeeList="changeFeeList" />
    </el-dialog>

    <!-- 添加快录 -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.SnapshotFee')"
      :visible.sync="addQRRow.isVisible"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <AddQRCmp
        ref="addQRRef"
        :key="addQRRow.key"
        :payable-type="payableType"
        :query-fee-param="queryFeeParam"
        :query-form="queryForm"
        :expense-sub-list="addQRRow.expenseSubList"
        :fee-type-option="feeTypeOption"
        :select-data="selectArr"
        @saveFormSnapshot="onQRClose"
      />
    </el-drawer>

    <!-- 导入快录 -->
    <importQuickRecording
      ref="importQRRef"
      :operator-list="operatorList"
      :outlets-list="outletsList"
      :fee-type-list="feeTypeOption"
      :provider-channel-list="providerChannelList"
      :payable-type="payableType"
    />

    <!-- 更新干支线重算数据-->
    <el-dialog
      :append-to-body="true"
      :close-on-press-escape="false"
      :title="$t('receivablePayable.updateDataRecalculatePrice')"
      :visible.sync="showTransportation"
      width="600px"
    >
      <ImportTransport
        @importPrice="importTransportationPrice"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  // apiPayableSiteBillGenerateBillNumber,
  apiPayableSiteExpenseBatchDelete,
  apiPayableSiteExpenseExport,
  apiPayableSiteExpenseGetInfo,
  apiPayableSiteExpenseSetRemark,
  apiPayableTransportExpenseBatchDelete,
  apiPayableTransportExpenseExport,
  apiPayableTransportExpenseSetRemark,
  apiPayableSiteExpenseImportReCalculatePrice
} from '@/api/finance/receivables';
import { initGetData } from '@/views/finance/payableManage/feesPayable/component/utils.js';
import { cloneDeep } from 'lodash-es';
import { goResourceTaskList } from '@/utils/goExportList.js';
import {
  // beforeSearch,
  searchEmpty,
  QUERY_FEE_PARAM,
  L_TABLE_HEADER,
  AJD_TABLE_HEADER,
  DSP_TABLE_HEADER,
  TF_TABLE_HEADER,
  YJ_TABLE_HEADER
} from '@/views/finance/payableManage/feesPayable/enums.js';
import { setGenerateCheck } from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/utils.js';
import AddFee from '@/views/finance/payableManage/feesPayable/component/AddFeee/index.vue';
import DetailFee from '@/views/finance/payableManage/feesPayable/component/AddFeee/details.vue';
import AddQRCmp from '@/views/finance/payableManage/feesPayable/component/AddQRcmp.vue';
import AccountsPayable from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/index.vue';
import AccountsPayableDialog from '@/views/finance/payableManage/feesPayable/component/AccountsPayable/dialog.vue';
import importAddFees from '@/views/finance/payableManage/feesPayable/ImportCmp/importAddFees.vue';
import importEditFees from '@/views/finance/payableManage/feesPayable/ImportCmp/importEditFees.vue';
import importQuickRecording from '@/views/finance/payableManage/feesPayable/ImportCmp/importQuickRecording.vue';
import RerunDialog from '@/views/finance/payableManage/feesPayable/AJDDispatch/rerunDialog.vue';
import importDsp from '@/views/finance/payableManage/feesPayable/ImportCmp/importDsp.vue';

const permissionList = {
  1: {
    edit: 'btn:finance:payableManagement:hut:addEdit',
    export: 'btn:finance:payableManagement:hut:export',
    meet: 'btn:finance:payableManagement:hut:GeneratePayables',
    rerun: 'btn:finance:payableManagement:hut:RecalculateThePrice'
  },
  2: {
    edit: 'btn:finance:payableManagement:threeCollect:addEdit',
    export: 'btn:finance:payableManagement:threeCollect:export',
    meet: 'btn:finance:payableManagement:threeCollect:GeneratePayables',
    rerun: 'btn:finance:payableManagement:threeCollect:RecalculateThePrice'
  },
  3: {
    edit: 'btn:finance:payableManagement:ajd:addEdit',
    export: 'btn:finance:payableManagement:ajd:export',
    meet: 'btn:finance:payableManagement:ajd:GeneratePayables',
    rerun: 'btn:finance:payableManagement:ajd:RecalculateThePrice'
  },
  4: {
    edit: 'btn:finance:payableManagement:dsp:addEdit',
    export: 'btn:finance:payableManagement:dsp:export',
    meet: 'btn:finance:payableManagement:dsp:GeneratePayables',
    rerun: 'btn:finance:payableManagement:dsp:RecalculateThePrice'
  },
  5: {
    edit: 'btn:finance:payableManagement:transportation:addEdit',
    export: 'btn:finance:payableManagement:transportation:export',
    meet: 'btn:finance:payableManagement:transportation:GeneratePayables',
    rerun: 'btn:finance:payableManagement:transportation:RecalculateThePrice'
  },
  6: {
    edit: 'btn:finance:payableManagement:postOfficeDelivery:addEdit',
    export: 'btn:finance:payableManagement:postOfficeDelivery:export',
    meet: 'btn:finance:payableManagement:postOfficeDelivery:GeneratePayables',
    rerun: 'btn:finance:payableManagement:postOfficeDelivery:RecalculateThePrice'
  }
};
export default {
  name: 'ActionCenter',

  components: {
    AddFee,
    DetailFee,
    AddQRCmp,
    AccountsPayable,
    AccountsPayableDialog,
    importAddFees,
    importEditFees,
    importQuickRecording,
    RerunDialog,
    importDsp,
    DelButCmp: () => import('./DelButCmp.vue'),
    RemarkButCmp: () => import('./RemarkButcmp.vue'),
    RecalculateButCmp: () => import('./RecalculateButcmp.vue'),
    recalculate: () => import('@/views/finance/payableManage/feesPayable/component/AddFeee/recalculate.vue'),
    CustomStatusBar: () => import('@/views/finance/cmp/CustomStatusBar.vue'),
    ImportTransport: () => import('@/views/finance/payableManage/feesPayable/ImportCmp/importTransportation.vue')
  },

  props: {
    // 搜索条件
    queryForm: {
      type: Object,
      required: true
    },

    // 多选
    selectData: {
      type: Array,
      required: true
    },

    // 业务类型
    businessType: {
      type: [Number, String],
      default: null, // 2 揽收 3 派送 1 运输干支线
      required: true
    },

    // 账单类型
    payableType: {
      type: [Number, String],
      default: '', // 1 安俊 2 第三方 3 AJD 4 DSP 5 运输（干/支线） 6 邮局投递
      required: true
    }

    // 自定义列选中列
    // checkedColumns: {
    //   type: Array,
    //   default: () => []
    // },

    // customColumnId: {
    //   type: [Number, String],
    //   default: null, // 自定义列id
    // },
  },

  data() {
    return {
      isAddAndEdit: false,
      providerList: [], // 获取应付主体选项
      providerData: [], // 获取运输主体
      outletsList: [], // 获取站点
      operatorList: [], // 获取操作人
      feeTypeOption: [], // 获取费用类型
      providerChannelList: [], // 获取服务商渠道
      queryFeeParam: {}, // 快录详情参数
      isImportAdd: false, // 导入添加费用
      isImportEdit: false, // 导入修改费用
      showImportTemplate: false, // DSP导入重算dialog
      calculationType: null, // 价格重算类型 0 查询结果 1 勾选结果 2 DSP导入 3 DSP导入重量

      // 非快录添加
      addNotQRRow: {
        key: 1,
        addType: 2
      },

      // 非快录详情
      editNotQRRow: {
        key: 1
      },

      // 添加快录
      addQRRow: {
        expenseSubList: [], // 费用详情

        isVisible: false, // 弹窗
        key: 2
      },
      showRecalculateThePrice: false, // 运输干支线价格重算弹窗
      permissionList,
      showTransportation: false // 干支线更新重算
    };
  },

  computed: {
    // 获取多选选中的值(只含id)
    selectIdArr() {
      const arr = this.selectData;
      if (arr.length === 0) {
        return [];
      }

      return arr.map(item => {
        return item.id;
      });
    },

    // 获取多选选中的值
    selectArr() {
      return cloneDeep(this.selectData);
    },

    // 重算title
    titleList() {
      return {
        1: this.$t('receivablePayable.RecalculateThePrice'),
        2: this.$t('receivablePayable.ImportCalculatePrices'),
        3: this.$t('receivablePayable.ImportWeightsCalculatePrices')
      };
    }
  },

  // activated() {
  //   this.initData();
  // },

  created() {
    this.initData();
  },

  methods: {
    // 打开运输干支线重新计算价格弹窗
    // 单号、时间必选一个
    onRecalculateThePrice(type) {
      const formData = cloneDeep(this.queryForm);
      const params = formData.params;
      if (type === 1) {
        if (!params.transportNumberList.length && !params.startTime) {
          this.$message.warning(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
          return;
        }
        try {
          // const getDaysBetweenDates = (dateStr1, dateStr2) => {
          //   if (!dateStr1 || !dateStr2) {
          //     return 0;
          //   }
          //   const date1 = new Date(dateStr1);
          //   const date2 = new Date(dateStr2);
          //   // 可选：验证输入日期的有效性
          //   if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          //     throw new Error('Invalid date input');
          //   }
          //
          //   // 计算天数差
          //   const millisecondsPerDay = 24 * 60 * 60 * 1000;
          //   const diffInMilliseconds = Math.abs(date2 - date1);
          //   return Math.ceil(diffInMilliseconds / millisecondsPerDay);
          // };
          // const day = getDaysBetweenDates(params.startTime, params.endTime);
          const count = this.$emit('getTotal');
          // if (day > 7 || count > 100000) {
          //   // 一次仅能重算同一业务类型，业务时间为7天且数据量小于10w的数据
          //   this.$message.warning(this.$t('receivablePayable.OnlyDataSameServiceType'));
          //   return;
          // }
          if (count > 100000) {
            // 一次仅能重算同一业务类型，数据量小于10w的数据
            this.$message.warning(this.$t('receivablePayable.dataVolume100K'));
            return;
          }
          let msg;
          if (this.selectData.length > 0) {
            msg = this.$t('receivablePayable.PressRecalculateWithChecked');
          } else {
            msg = this.$t('receivablePayable.Recalculate');
          }
          this.$confirm(
            msg, // 点击”确认“按钮，将按照系统最新价格表对当前查询的所有“费用来源”为“系统生成”的费用进行重新核算，是否确认？
            this.$t('basicData.tips'), {
              confirmButtonText: this.$t('basicData.determine'), // '确定',
              cancelButtonText: this.$t('basicData.Cancel'), // '取消',
              type: 'warning'
            }).then(() => {
            const query = {
              pageNumber: 1,
              pageSize: 10,
              orderDirection: 'desc',
              orderProperty: '',
              params: {
                ...params
              }
            };
            const obj = {
              postData: query,
              isBool: true
            };

            this.$emit('recalculatePrice', obj);
          }).catch(() => {
            console.info('用户点击取消');
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        // 导入重算弹窗
        this.showTransportation = true;
      }

      // const { transportNumberList, startTime, endTime } = this.queryForm.params;
      // if (transportNumberList && transportNumberList.length > 0 || (startTime && endTime)) {
      //   const query = {
      //     pageNumber: 1,
      //     pageSize: 10,
      //     orderDirection: 'desc',
      //     orderProperty: '',
      //     params: {
      //       ...this.queryForm.params
      //     }
      //   };
      //   const obj = {};
      //   obj.postData = query;
      //   obj.isBool = true;
      //   this.$emit('recalculatePrice', obj);
      // } else {
      //   this.$message.error(this.$t('receivablePayable.businessTimeOrOrderNumberCannotBeEmpty'));
      // }
    },
    saveReCalculate(data) {
      if (data) {
        const query = {
          pageNumber: 1,
          pageSize: 10,
          orderDirection: 'desc',
          orderProperty: '',
          params: {
            loadUserIdList: data.dispatcherList,
            startDate: data.queryDate[0],
            endDate: data.queryDate[1]
          }
        };
        const obj = {};
        obj.postData = query;
        obj.isBool = true;
        this.$emit('recalculatePrice', obj);
      }
      this.showRecalculateThePrice = false;
    },
    // 初始化数据
    initData() {
      this.isAddAndEdit = true;
      initGetData({ payableType: this.payableType }).then(res => {
        this.providerList = res[0];// 应付主体选项
        this.providerData = res[1];// 应付运输主体
        this.outletsList = res[2];// 获取站点
        this.providerChannelList = res[3]; // 服务商渠道
        this.operatorList = res[4];// 操作人
        this.feeTypeOption = res[5];// 费用类型
      }).catch(err => console.error(err)).finally(() => {
        this.isAddAndEdit = false;
      });
    },

    // 刷新列表
    refresh() {
      this.$emit('refresh');
    },

    // 批量添加费用
    onBatchAddingcosts() {
      this.$refs.notQRAddRef.open();
    },

    // 非快录详情
    openNotQRDetail(row) {
      this.queryFeeParam = cloneDeep(row);
      this.$refs.notQRDetailsRef.open();
    },

    // 快录添加
    onQR() {
      let obj = { ...QUERY_FEE_PARAM };
      if (this.selectArr.length > 0) {
        obj = cloneDeep(this.selectArr[0]);
        obj.waybillNumber = obj.waybillNumber.replace('QR', '');
        obj.id = null;
      }
      this.queryFeeParam = obj;
      this.addQRRow.isVisible = true;
      this.addQRRow.key += 1;
    },

    // 查看快录详情
    onQREditFee(row) {
      apiPayableSiteExpenseGetInfo(row).then(res => {
        if (res.code === 200) {
          const obj = cloneDeep(res.data);
          obj.waybillNumber = obj.waybillNumber.replace('QR', '');
          this.queryFeeParam = obj;
          this.addQRRow.expenseSubList = res.data.expenseSubList;
          this.addQRRow.key += 1;
          this.addQRRow.isVisible = true;
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 导入添加费用关闭
    onImportAddClose() {
      this.isImportAdd = false;
    },
    // 导入修改费用关闭
    changeFeeList() {
      this.isImportEdit = false;
    },
    // 快录添加关闭
    onQRClose(isBool) {
      this.addQRRow.isVisible = false;

      isBool && this.refresh();
    },

    // 批量添加快录
    onQRImport() {
      this.$refs.importQRRef.open();
    },

    // 生成应付
    onGenerateCope() {
      const { params } = this.queryForm;
      // 判断搜索条件是否为空
      {
        const isBool = searchEmpty(params);

        if (isBool) {
          return;
        }
      }
      // 判断业务类型及操作人
      const [isBool, val] = setGenerateCheck(this.selectArr, params);
      if (!isBool) {
        return;
      }

      // 运输业务判断主体、运输类型
      const { providerId, routeType } = params;
      console.log('params', providerId, routeType);
      if (this.payableType === 5) {
        if (!providerId || !routeType) {
          this.$message.warning(this.$t('basicData.querySubjectAndTransportTypeCannotBeEmpty'));
          return;
        }
      }

      // if (this.payableType !== 6) {
      this.$refs.generateCopeTimeRef.open(val);
      // return false;
      // }
      // console.log('生成应付成功，后续处理函数执行中...');
      // this.onPostalDelivery();
    },
    // 邮局派送生成应付
    // onPostalDelivery() {
    //   // 校验时间和单号二选一
    //   {
    //     const isBool = beforeSearch(this.queryForm.params);
    //     if (!isBool) {
    //       return;
    //     }
    //   }
    //   const ids = this.selectData.map(item => item.id);
    //   const param = {
    //     ...this.queryForm.params,
    //     ids
    //   };
    //   const tips = ids.length > 0 ? this.$i18n.t('receivablePayable.AreYouSureToGenerateAccountsPayableForTheSelectedData') // 确定给选中数据生成应付？
    //     : this.$i18n.t('receivablePayable.UncheckedDataWillGenerateAccountsPayableForAllQueriedDataConfirmToGenerateAccountsPayable'); // '未勾选数据将会给查询到的所有数据都生成应付，确定生成应付？';
    //
    //   try {
    //     this.$confirm(tips, this.$i18n.t('basicData.tips'), // '提示'
    //       {
    //         confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
    //         cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       apiPayableSiteBillGenerateBillNumber(param).then(res => {
    //         if (res.code === 200) {
    //           this.generateReceivablesSuccess(res.data);
    //         }
    //       }).catch(err => console.error(err));
    //     }).catch(() => {});
    //   } catch (e) {
    //     console.log(e.message || e.toString());
    //   }
    // },

    // 生成应付 后续处理函数
    generateReceivablesSuccess(data) {
      this.$refs.generateCopeListRef.open(data);
    },

    // 备注提交
    asyncRemark(str) {
      const param = {
        condition: {
          ...this.queryForm.params,
          ids: this.selectIdArr
        },
        remark: str,
        payableType: this.payableType
      };
      const API = this.payableType === 5 ? apiPayableTransportExpenseSetRemark : apiPayableSiteExpenseSetRemark;
      return API(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // '保存成功'
          this.refresh();
        }
      });
    },

    /**
     * 默认导出所有
     */
    onExport() {
      const isBool = searchEmpty(this.queryForm.params);
      if (isBool) return;

      const prop = [];
      const label = [];
      let TABLE_HEADER = L_TABLE_HEADER;
      const HEADER_MAP = {
        payableType: {
          5: TF_TABLE_HEADER,
          6: YJ_TABLE_HEADER,
          3: AJD_TABLE_HEADER,
          4: DSP_TABLE_HEADER
        },
        businessType: {
          2: L_TABLE_HEADER
        }
      };
      if (HEADER_MAP.payableType[this.payableType]) {
        TABLE_HEADER = HEADER_MAP.payableType[this.payableType];
      } else if (HEADER_MAP.businessType[this.businessType]) {
        TABLE_HEADER = HEADER_MAP.businessType[this.businessType];
      }
      // 导出干掉客户信息
      TABLE_HEADER.forEach(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: this.selectIdArr
      };
      const fn = this.payableType === 5 ? apiPayableTransportExpenseExport : apiPayableSiteExpenseExport;
      fn(param).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      }).catch(err => {
        console.error(err);
      });
    },

    /**
     * 根据费用类型删除费用
     * @param code 费用编号
     */
    asyncDel(code) {
      const param = {
        ...this.queryForm.params,
        feeCode: code, // 费用编号
        ids: this.selectIdArr // 多选订单数据
      };
      const API = this.payableType === 5 ? apiPayableTransportExpenseBatchDelete : apiPayableSiteExpenseBatchDelete;
      return API(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // '操作成功'
          this.refresh();
        }
      });
    },
    // 重算价格（AJD）
    onRerun() {
      this.$refs.rerunRef.open();
    },
    onRecalculate(data) {
      const obj = {};
      obj.postData = data;
      obj.isBool = true;
      this.$emit('recalculatePrice', obj);
    },
    // DSP重新计算
    onRerunDSP(type) {
      const formData = cloneDeep(this.queryForm.params);
      if (type === 1) {
        if (!formData.startTime) {
          this.$message.warning(this.$t('receivablePayable.TheBusinessTimeCannotBeEmpty'));
          return;
        }
        try {
          const getDaysBetweenDates = (dateStr1, dateStr2) => {
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);

            // 可选：验证输入日期的有效性
            if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
              throw new Error('Invalid date input');
            }

            // 计算天数差
            const millisecondsPerDay = 24 * 60 * 60 * 1000;
            const diffInMilliseconds = Math.abs(date2 - date1);
            return Math.ceil(diffInMilliseconds / millisecondsPerDay);
          };

          const day = getDaysBetweenDates(formData.startTime, formData.endTime);
          const count = this.$emit('getTotal');
          if (day > 7 || count > 100000) {
            // 一次仅能重算同一业务类型，业务时间为7天且数据量小于10w的数据
            this.$message.warning(this.$t('receivablePayable.OnlyDataSameServiceType'));
            return;
          }
          let msg;
          if (this.selectData.length > 0) {
            msg = this.$i18n.t('receivablePayable.PressRecalculateWithChecked');
          } else {
            msg = this.$i18n.t('receivablePayable.Recalculate');
          }
          this.$confirm(
            msg, // 点击”确认“按钮，将按照系统最新价格表对当前查询的所有“费用来源”为“系统生成”的费用进行重新核算，是否确认？
            this.$i18n.t('basicData.tips'), {
              confirmButtonText: this.$i18n.t('basicData.determine'), // '确定',
              cancelButtonText: this.$i18n.t('basicData.Cancel'), // '取消',
              type: 'warning'
            }).then(() => {
            const obj = {
              key: new Date().getTime(),
              isBool: true
            };
            this.$emit('recalculatePrice', obj);
          }).catch(() => {
            console.info('用户点击取消');
          });
        } catch (error) {
          this.$message.warning(error);
        }
      } else {
        this.calculationType = type;
        this.showImportTemplate = true;
      }
    },
    // dsp导入重算
    importPrice(data) {
      this.showImportTemplate = false;
      const obj = {
        importData: data,
        key: new Date().getTime(),
        isBool: true,
        calculationType: this.calculationType // 重算类型
      };
      this.$emit('recalculatePrice', obj);
    },
    // 干支线导入重算
    importTransportationPrice(data) {
      console.log(data, '干支线导入重算');
      this.showTransportation = false;
      apiPayableSiteExpenseImportReCalculatePrice(data).then(res => {
        if (res.code === 200) {
          console.log(res, '干支线导入重算');
          const obj = {
            postData: {
              pageNumber: 1,
              pageSize: 10
            },
            isBool: true
          };

          this.$emit('recalculatePrice', obj);
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

